import React from 'react'
import style from './card.module.css'

function Anish() {
  return (
    <div className = {style.sumit}>
        <img src='https://edge.uacdn.net/static/thumbnail/user/f9e6c9ecec784bc5939878cd81c8ef95.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img'/>
        <div>
            <h1>Anish Pathak</h1> 
            <p>
                Experience - 12 years Founder Defence Sarathi
                  Associated with Cadet Academy(NDA/Airforce/XY/AFCAT/CDS)
                Career Launcher(CAT/CLAT/IPM)  
            </p> 
          <p>Teaches Crash Course and 10 more</p>
        </div> 
    </div>
  )
}

export default Anish;